<template>
  <div id="sidebar">
    <div class="header"><Logo :expanded="expanded" :isMobile="isMobile" /></div>
    <v-divider />
    <div class="body">
      <div>
        <div v-if="investorItems && investorItems.length > 0">
          <div v-for="item in investorItems" :key="item.title">
            <ItemTree
              :node="item"
              v-if="isInvestor"
              :menuExpanded="expanded"
              :isMobile="isMobile"
            />
          </div>
        </div>

        <div v-if="items && items.length > 0">
          <div v-for="item in items" :key="item.title">
            <ItemTree
              :node="item"
              v-if="!isInvestor"
              :menuExpanded="expanded"
              :isMobile="isMobile"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="expanded || isMobile" class="footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import Logo from "./Logo";
import Footer from "./Footer";
import ItemTree from "./ItemTree";
import { getComponent, getPlants } from "@/models/lib.js";
import { mapGetters } from "vuex";

export default {
  name: "SideBar",
  components: {
    ItemTree,
    Logo,
    Footer,
  },
  props: {
    expanded: Boolean,
    isMobile: Boolean,
  },
  data() {
    return {
      currentUser: undefined,
      error: "",
      plants: [],
      options: {
        itemPlantKey: "plants",
        routeForPlants: "plants",
      },
      features: [],
      investors: [],
      templateSideBar: {},
      param: { name: "SideBar", feature_name: "Menu" },
    };
  },
  mounted() {
    this.start();
  },
  computed: {
    ...mapGetters(["isUserStaff", "isInvestor", "getUser"]),
    items() {
      return this.features;
    },
    investorItems() {
      return this.investors;
    },
  },
  methods: {
    start() {
      this.currentUser = this.getUser;
      this.mountNavigationBar();
    },
    async mountNavigationBar() {
      try {
        this.templateSideBar = await require("./data/template.json");
        if (this.isInvestor) {
          this.investors = this.templateSideBar.investors;
          return;
        }
        const config = await this.setConfig();
        const features = this.templateSideBar.features;
        const availableElements = Object.keys(features);
        config.forEach((element) => {
          if (!features[element]) {
            console.error(
              `[MENU-CONFIG] Invalid value '${element}', values available ${availableElements} `
            );
            return;
          }
          this.features.push(features[element]);
        });
      } catch (error) {
        console.error(error);
      }
    },
    async setConfig() {
      let config = await this.getSideBar();
      if (config.indexOf("plants") !== -1) {
        this.getChildsPlants();
      }

      return config;
    },
    async getSideBar() {
      const features = this.templateSideBar.features;
      const availableElements = Object.keys(features);
      let sideBar;
      let component = await getComponent(this.param);
      if (component) {
        await component.setSpecific();
        sideBar = component.findSpecific((e) => e.name == "sidebar");
        if (!sideBar)
          console.error("Menu SideBar Specific measurement not found");
      }
      return sideBar ? sideBar.referenceValue : availableElements;
    },
    async getChildsPlants() {
      this.plants = await getPlants();
      let { routeForPlants } = this.options;
      let child = [];
      this.plants.forEach((plant) => {
        const { name, id, sourceType } = plant;
        child.push({
          title: name,
          routeName: routeForPlants,
          icon: this.defineIcon(sourceType),
          args: [sourceType, id],
        });
      });
      this.templateSideBar.features.plants.child = child;
    },
    defineIcon(value) {
      switch (value) {
        case "EOL":
          return "windy";
        case "PCH":
          return "drop-invert";
        case "SOL":
          return "sun";
        case "UTE":
          return "thermostat";
        default:
          return "domain";
      }
    },
  },
};
</script>

<style scoped lang="css">
#sidebar {
  display: grid;
  grid-template-rows: 49px 5px auto 35px;
  height: 100%;
}
.header {
  max-width: 168px;
  max-height: 49px !important;
  align-self: center;
}
.body {
  /* overflow-y: scroll; */
  overflow-x: hidden;
}

.footer {
  -webkit-box-shadow: 0px -1px 2px 0px rgba(0, 0, 0, 0.03);
  -moz-box-shadow: 0px -1px 2px 0px rgba(0, 0, 0, 0.03);
  box-shadow: 0px -1px 2px 0px rgba(0, 0, 0, 0.03);
}
.body::-webkit-scrollbar-track {
  background-color: transparent !important;
}
.body::-webkit-scrollbar {
  width: 3px;
}

.body::-webkit-scrollbar-thumb {
  background-color: #bdbdbd81;
}
</style>
